/**
 * Creative Analysis activation gate (Task 230, FE side).
 *
 * Mirrors the backend env gate on `request-creative-analysis`: until creative
 * analysis is explicitly enabled (the C2 worker exists and the EF's
 * `CREATIVE_ANALYSIS_ENABLED` is on), the Analyze action stays clickable but is
 * a safe no-op — it shows the friendly message and makes NO backend call, so no
 * job is created and no cost is incurred. Fail-safe: disabled by default.
 */

/** Friendly Arabic copy shown while creative analysis is disabled. */
export const CREATIVE_ANALYSIS_DISABLED_MESSAGE =
  'تحليل المحتوى جاهز للتفعيل قريباً — لم يتم تشغيل أي تحليل بعد.';

/**
 * FE activation flag for creative analysis. Default OFF (fail-safe). Flip to
 * `true` only once the C2 worker AND the backend gate
 * (`CREATIVE_ANALYSIS_ENABLED=true`) are live. While off, the UI must not call
 * the enqueue endpoint.
 */
export function isCreativeAnalysisEnabled(): boolean {
  return false;
}

/** Minimal shape of a `request-creative-analysis` response for gate checks. */
export interface CreativeAnalysisResponseLike {
  readonly status?: string;
  readonly reason?: string;
}

/**
 * True when a `request-creative-analysis` response is the typed disabled
 * activation-gate envelope (`{ status: 'disabled', reason:
 * 'creative_analysis_not_enabled' }`). Used by the live Analyze wiring
 * (Milestone D) to render the friendly message instead of treating the no-op as
 * a real queued job.
 */
export function isCreativeAnalysisDisabledResponse(
  data: CreativeAnalysisResponseLike | null | undefined,
): boolean {
  return data?.status === 'disabled' && data?.reason === 'creative_analysis_not_enabled';
}
